<template>
    <div class="more-effective-container">
        <PageHeader title="疗效跟踪" />
        <div class="base-box" v-watermark>
            <div class="title-box">
                <div class="base-title">患者信息</div>
            </div>
            <TopHeader :user-info="userInfo" />
        </div>
        <div class="base-box" v-watermark>
            <van-tabs v-model="active" class="tabs-box" :swipe-threshold="4">
                <van-tab title="病情信息" />
                <van-tab title="瞑眩反应" />
                <van-tab title="入药反应" />
                <van-tab title="新发症状" />
                <van-tab title="停/续药安排" />
            </van-tabs>
            <template v-if="active === 0">
                <DiseaseInfo :userInfo="userInfo" :patient-info="patientInfo" />
            </template>
        </div>
        <div class="base-box base-no-padding">
            <template v-if="active === 0">
                <TreatmentInfo :listData="therapeuticEvaluationList" />
            </template>
            <template v-else>
                <BaseDddInfo :type="tabInfo.type" :disabled="true" :data-list="tabInfo.listData" />
            </template>
        </div>
        <div class="safe-area-inset-bottom"></div>
        <!-- 按钮 -->
        <div class="bottom-box safe-area-inset-bottom">
            <div class="bottom-container">
                <van-button type="primary" block @click="goBackHome" class="button-box">返回首页</van-button>
            </div>
        </div>
    </div>
</template>
<script>
import {
    getUserInfo,
    getTabData,
    getPatient,
    getTherapeuticEvaluation,
} from "@/api/moreEffective";
import PageHeader from "@/components/PageHeader/index.vue";
import TopHeader from "./components/topHeader.vue";
import DiseaseInfo from "./components/diseaseInfo.vue";
import TreatmentInfo from "./components/treatmentInfo.vue";
import BaseDddInfo from "./components/baseDddInfo.vue";
export default {
    name: "MoreEffective",
    data() {
        return {
            active: 0,
            reqCond: {
                userMemberId: "",
            },
            // 用户信息
            userInfo: {
                illnessSyntheticDes: "",
                typeList: [],
            },
            // tab 切换数据
            tabAllData: {
                tabList1: [],
                tabList2: [],
                tabList3: [],
                tabList4: [],
            },
            // 患者病情详情
            patientInfo: {},
            // 患者冶疗疗程列表
            therapeuticEvaluationList: [],
        };
    },
    provide() {
        return {
            updataTherapeuticEvaluationData: () =>
                this.getTherapeuticEvaluationData(),
        };
    },
    methods: {
        goBackHome() {
            this.$route.params.isUpDate = false;
            this.$router.back();
        },
        init() {
            this.reqCond.userMemberId = this.$route.query.id;
            this.getPageInfo();
            this.getaAllTabData();
            this.getPatientInfo();
            this.getTherapeuticEvaluationData();
            this.$nextTick(() => {
                document.documentElement.scrollTop = 0;
            });
        },
        // 用户信息
        async getPageInfo() {
            try {
                const { data } = await getUserInfo({
                    id: this.reqCond.userMemberId,
                });
                data.tagList = (data.tagList || []).map((item) => ({
                    id: item.value,
                    name: item.text,
                }));
                this.userInfo = data;
            } catch (error) {
                console.log(error);
            }
        },
        // tab切换数据
        async getaAllTabData() {
            this.tabAllData = {
                tabList1: [],
                tabList2: [],
                tabList3: [],
                tabList4: [],
            };
            try {
                const { data } = await getTabData({
                    userMemberId: this.reqCond.userMemberId,
                    type: null,
                });
                JSON.parse(JSON.stringify(data || [])).forEach((item) => {
                    if (item.type === 4 || item.type === 5) {
                        this.tabAllData["tabList4"].push(item);
                    } else {
                        this.tabAllData[`tabList${item.type}`].push(item);
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
        // 患者病情详情
        async getPatientInfo() {
            try {
                const { data } = await getPatient(this.reqCond.userMemberId);
                this.patientInfo = JSON.parse(JSON.stringify(data || {}));
            } catch (error) {
                console.log(error);
            }
        },
        // 疗效评价信息
        async getTherapeuticEvaluationData() {
            try {
                const { data } = await getTherapeuticEvaluation({
                    userMemberId: this.reqCond.userMemberId,
                });
                // 处理数据
                this.therapeuticEvaluationList = JSON.parse(JSON.stringify(data || []));
            } catch (error) {
                console.log(error);
            }
        },
    },
    components: {
        PageHeader,
        TopHeader,
        DiseaseInfo,
        TreatmentInfo,
        BaseDddInfo,
    },
    // created() {
    //     // sessionStorage.setItem(
    //     //   "userToken",
    //     //   "gnFWyFTIx8xD8p96mrNzGE0gdUUwdgtGYOCrkbUB0c239vx2icA5g0mKHM5HSIqhrKvh4Sn7R4CRyTr2fcahNB5pS4szYELslT/lGa00cSEy7JrfAA5vj8uPDuBA3/Mt"
    //     // );
    //     this.init();
    // },
    activated() {
        if (this.$route.params.isUpDate) {
            this.init();
            this.$route.params.isUpDate = false;
        }
        console.log("activated");
    },
    deactivated() {
        console.log("deactivated");
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            console.log(from.name);
            if (from.name !== "EditMoreEffective") vm.init();
        });
    },
    computed: {
        tabInfo() {
            return {
                type: this.active,
                listData: this.tabAllData[`tabList${this.active}`] || [],
            };
        },
    },
};
</script>
<style scoped lang="scss">
.safe-area-inset-bottom {
    padding-bottom: constant(safe-area-inset-bottom) !important;
    padding-bottom: env(safe-area-inset-bottom) !important;
}

:deep(.v-select) {
    line-height: 30px;
    box-sizing: border-box;
    height: 30px;
    width: auto;

    .vs__dropdown-toggle {
        height: 100%;
    }

    .vs__dropdown-toggle {
        padding: 0;
        overflow: hidden;
    }

    .vs__dropdown-option,
    .vs__selected-options {
        font-size: 16px;
    }

    .vs__selected,
    .vs__selected-options {
        font-size: 16px;
    }

    .vs__selected {
        margin: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: block;
    }

    .vs__search {
        position: absolute;
        right: -99999;
        width: 0;
        height: 0;
    }

    .vs__dropdown-menu {
        right: 0;
        left: auto;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
        box-sizing: border-box;
    }

    .vs__actions {
        padding: 0 5px;
    }

    .vs__dropdown-option {
        color: #333333;

        &:hover,
        .vs__dropdown-option--selected {
            background: #f5f5f5;
            color: #333333;
        }
    }

    .vs__dropdown-option--highlight {
        background: #f5f5f5;
        color: #333333;
    }

    .icon-box {
        transform: rotate(90deg);
        color: #999999;
        font-size: 12px;
    }
}

:deep(.tag-operate) {
    display: flex;
    align-items: center;
    cursor: pointer;

    .icon-title {
        color: #0082ef;
        font-size: 14px;
    }

    .icon-box {
        width: 22px;
        height: 22px;
        background: url("~@/assets/images/moreEffective/left.png") center/cover no-repeat;
        margin-left: 4px;
    }
}

.more-effective-container {
    padding: 0 10px 100px;

    .base-box {
        background: #ffffff;
        border-radius: 4px;
        padding: 15px;
        overflow: hidden;

        &+.base-box {
            margin-top: 12px;
        }

        .title-box {
            display: flex;

            .base-title {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
                line-height: 21px;
                position: relative;

                &::after {
                    position: absolute;
                    content: "";
                    width: 100%;
                    bottom: 0;
                    left: 0;
                    height: 3px;
                    background: linear-gradient(90deg,
                            #0082ef 0%,
                            rgba(0, 130, 239, 0) 100%);
                    border-radius: 3px;
                }
            }
        }
    }

    .base-no-padding {
        padding: 0;
    }

    :deep(.van-tabs) {

        .van-tabs--line,
        .van-tabs__wrap {
            height: 30px !important;
        }

        .van-tabs__nav--line.van-tabs__nav--complete {
            padding-left: 0;
            padding-right: 0;
        }

        .van-tab {
            font-size: 16px;
            font-weight: 500;
            color: #666666;
            padding: 0 7px;
            flex: 0 1 auto;
            flex-shrink: 0;

            &:first-child {
                padding-left: 0;
            }

            &:nth-child(5) {
                padding-right: 0;
            }

            &.van-tab--active {
                font-size: 18px;
                font-weight: bold;
                color: #333333;
            }
        }

        .van-tabs__nav--line {
            padding-bottom: 0;
        }

        .van-tabs__line {
            width: 74px;
            height: 3px;
            background: linear-gradient(90deg, #0082ef 0%, rgba(0, 130, 239, 0) 100%);
            border-radius: 3px;
            bottom: 7px;
        }
    }

    .bottom-box {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;

        border-radius: 0px 0px 0px 0px;
        z-index: 9999999;
        background: #ffffff;

        .bottom-container {
            height: 84px;
            background: #ffffff;
            box-sizing: border-box;
            padding: 16px 25px;

            .button-box {
                background: #0082ef;
                font-size: 20px;
                font-weight: bold;
                color: #ffffff;
                border-radius: 8px;
                border: none;
            }
        }
    }
}
</style>
